import type { CompanyDomainValue } from "app/pages/sales-intelligence/domain/leads/types/website";
import type { BaseLeadsSearchRow, LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { rowTypeGuard } from "app/pages/sales-intelligence/sub-modules/company-search/types/type-guards";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

export const getMainCompanyDomainOrDefault = <Row extends LeadsSearchRow>(row: Row | undefined): CompanyDomainValue => {
    const { company_domains } = row ?? {};

    if (is.undefined(company_domains) || company_domains === null || company_domains?.length === 0) {
        return {
            headQuarter: 0,
            domain: "",
            isMainDomain: false,
        };
    }

    return company_domains.find((domain) => domain.isMainDomain) ?? company_domains[0];
};

export const getLeadDomainFromRow = <R extends BaseLeadsSearchRow>(tableRow: R | undefined): string => {
    if (rowTypeGuard.isWebsiteBaseTableRow(tableRow)) {
        return tableRow.site;
    }

    if (rowTypeGuard.isCompanyDomainsBaseTableRow(tableRow)) {
        return getMainCompanyDomainOrDefault(tableRow).domain;
    }

    return "";
};
